/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_GroupInputs */

const vi_shop_home_link_group = /** @type {(inputs: Shop_Home_Link_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhóm SP`)
};

/**

* @param {Shop_Home_Link_GroupInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_group = /** @type {((inputs?: Shop_Home_Link_GroupInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_GroupInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_group(inputs)
});